import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { CentsDataGrid } from 'components/common/dataGrid/dataGrid';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { searchStores } from 'api/admin/stores/stores';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 1 },
  { headerName: 'Name', field: 'name', flex: 2 },
  { headerName: 'Business Name', field: 'businessName', flex: 2 },
  { headerName: 'Business ID', field: 'businessId', flex: 1, type: 'number' },
  { headerName: 'Region Name', field: 'regionName', flex: 1 },
  { headerName: 'District Name', field: 'districtName', flex: 1 },
  { headerName: 'Address', field: 'address', flex: 1 },
  { headerName: 'City', field: 'city', flex: 1 },
  { headerName: 'State', field: 'state', flex: 1 },
  { headerName: 'Zip Code', field: 'zipCode', flex: 1 },
  { headerName: 'Phone Number', field: 'phoneNumber', flex: 1 },
  { headerName: 'Created At', field: 'createdAt', flex: 1 },
  { headerName: 'Stripe Location ID', field: 'stripeLocationId', flex: 1 },
  { headerName: 'DCA License', field: 'dcaLicense', flex: 1 },
  { headerName: 'Delivery Enabled', field: 'isDeliveryEnabled', type: 'boolean', flex: 1 },
  { headerName: 'Door Dash Enabled', field: 'isDoorDashEnabled', type: 'boolean', flex: 1 },
];

const StoresTable = () => {
  const history = useHistory();
  const [searchInput, setSearchInput] = useState('');

  const { data: stores, isLoading } = useQuery(
    ['searchStores', { searchInput }],
    async () => {
      const { data } = await searchStores(searchInput);
      return data.stores;
    },
    {
      onError: (error) => {
        // maintaining existing error handling behavior
        console.log(error);
      },
    },
  );

  const handleRowClick = ({ id }) => {
    history.push(`/stores/${Number(id)}`);
  };

  const search = (searchInput) => {
    setSearchInput(searchInput);
  };

  const handleCreateStoreClick = () => {
    history.push('/stores/new');
  };

  return (
    <div className="page-container">
      <div className="stores-header">
        <h1>Stores</h1>
        <button className="submit-button" onClick={handleCreateStoreClick}>
          Create Store
        </button>
      </div>
      <div className="stores-search-bar">
        <TableSearchBar placeholder="Find a store" onSearch={search} />
      </div>
      <CentsDataGrid
        tableName="STORES"
        data={stores ?? []}
        columns={COLUMNS}
        onRowClick={handleRowClick}
        isLoading={isLoading}
        defaultColumnVisibilityModel={{
          // hide properties specified here by default
          regionName: false,
          districtName: false,
        }}
      />
    </div>
  );
};

export default StoresTable;
